<template>
  <div class="collectionCardDoc">
    <documentation-container :title="title">
      <template slot="content">
        <div class="content-doc">
          <collection-card v-for="(collection, index) in collections" 
            :key="index" 
            :link="`home`"
            :img="collection.img" 
            :title="collection.title" 
            :description="collection.description" 
            :price="collection.price" 
            :pathName="`/home`"/>
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import CollectionCard from '@/components/Card/CollectionCard'
import DocumentationContainer from '@/components/DocumentationContainer'

export default {
  name: 'adx-collection-card-doc',
  components: {
    'collection-card': CollectionCard,
    'documentation-container': DocumentationContainer
  },
  data() {
    return {
      title: 'Collection Card',
      collections: [
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15'
        },
        {
          img: '/img/collection/airport_lounge.jpg',
          title: 'Airport',
          price: '15'
        },
        {
          img: '/img/collection/gym.jpg',
          title: 'Sport Area',
          price: '15'
        },
        {
          img: '/img/collection/office_building.jpg',
          title: 'Office Building',
          price: '15'
        },
        {
          img: '/img/collection/shopping_mall.jpg',
          title: 'Hangout Place',
          price: '15'
        },
        {
          img: '/img/collection/shopping_mall.jpg',
          title: 'Shopping Place',
          price: '15'
        },
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>